import Spinners from "components/Shared/Spinners"
import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import {
  Badge,
  BreadcrumbItem,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap"
import { getModifierGroupDetails } from "store/actions/modifierGroupAction"
import placeholderImage from "assets/images/placeholderImage.png"
import BackButton from "components/Shared/BackButton"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"

const ModifierGroupDetails = () => {
  const { t } = useTranslation()

  document.title = t("Modifier Group Details | Namq")

  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { loading, modifierGroupDetails } = useSelector(
    state => state.ModifierGroups
  )

  useEffect(() => {
    getOldValues()
  }, [])

  const getOldValues = () => {
    const payload = {
      id,
    }

    dispatch(getModifierGroupDetails(payload))
  }

  if (loading) return <Spinners />

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs />
          <Row>
            <Col lg={8}>
              <Card>
                <CardBody>
                  <CardTitle className="d-flex align-items-center">
                    <BackButton />
                    {t("Modifier Group Details")}
                  </CardTitle>
                  <div className="table-responsive">
                    {Object.values(modifierGroupDetails).length === 0 ? (
                      <p className="text-center">
                        {t("No modifier group details found")}
                      </p>
                    ) : (
                      <Table className="table-nowrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Id")}</th>
                            <td>{modifierGroupDetails._id}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Name(English)")}</th>
                            <td>{modifierGroupDetails.name || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Name(عربي)")}</th>
                            <td>{modifierGroupDetails.nameAr || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Status")}</th>
                            <td>
                              {modifierGroupDetails.status === 1 ? (
                                <Badge className="bg-success">
                                  {t("Active")}
                                </Badge>
                              ) : (
                                <Badge className="bg-danger">
                                  {t("Deactive")}
                                </Badge>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Image Type")}</th>
                            <td>{modifierGroupDetails.imageUrlType || "-"}</td>
                          </tr>
                          {/* <tr>
                            <th scope="row">Image URL</th>
                            <td>
                              <p style={{ maxWidth: "40%" }}>
                                {modifierGroupDetails.imageUrl || "-"}
                              </p>
                            </td>
                          </tr> */}
                          <tr>
                            <th scope="row">{t("Display Order")}</th>
                            <td>
                              {modifierGroupDetails.displayOrder !== undefined
                                ? modifierGroupDetails.displayOrder
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Minimum")}</th>
                            <td>
                              {modifierGroupDetails.minimum !== undefined
                                ? modifierGroupDetails.minimum
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Maximum")}</th>
                            <td>
                              {modifierGroupDetails.maximum !== undefined
                                ? modifierGroupDetails.maximum
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Max Modifiers Options")}</th>
                            <td>
                              {modifierGroupDetails.maxModifiersOptions !==
                              undefined
                                ? modifierGroupDetails.maxModifiersOptions
                                : "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Free Modifiers Count")}</th>
                            <td>
                              {modifierGroupDetails.freeModifiersCount !==
                              undefined
                                ? modifierGroupDetails.freeModifiersCount
                                : "-"}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={4}>
              <Card className="card_100_24">
                <CardBody>
                  <img
                    src={
                      modifierGroupDetails.imageUrl
                        ? modifierGroupDetails.imageUrl
                        : placeholderImage
                    }
                    alt=""
                    className="img-fluid d-block mx-auto"
                    style={{ height: "100%", objectFit: "contain" }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card className="card_100_24">
                <CardBody>
                  <CardTitle>{t("Modifiers")} </CardTitle>
                  {modifierGroupDetails?.modifiers?.length === 0 ? (
                    <p className="text-center my-3">
                      {t("No modifiers found")}
                    </p>
                  ) : (
                    <div className="table-responsive">
                      <Table className="table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>{t("S. No.")}</th>
                            <th>{t("Name(English)")}</th>
                            <th>{t("Name(عربي)")}</th>
                            <th>{t("Image Type")}</th>
                            <th>{t("Image")}</th>
                            <th>{t("Display Order")}</th>
                            <th>{t("Price")}</th>
                            <th>{t("Minimum")}</th>
                            <th>{t("Maximum")}</th>
                            <th>{t("Calories Count")}</th>
                            <th>{t("Status")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {modifierGroupDetails?.modifiers?.map(
                            (item, index) => (
                              <tr key={item._id}>
                                <td scope="row">{index + 1}</td>
                                <td scope="row">{item.name}</td>
                                <td scope="row">{item.nameAr}</td>
                                <td scope="row">{item.imageUrlType}</td>
                                <td scope="row">
                                  {
                                    <img
                                      src={item.imageUrl}
                                      alt=""
                                      style={{
                                        maxWidth: 100,
                                        maxHeight: 100,
                                        objectFit: "contain",
                                      }}
                                    />
                                  }
                                </td>
                                <td scope="row">{item.displayOrder}</td>
                                <td scope="row">
                                  {item.price}{" "}
                                  {item.countryCode === "SA" ? "SAR" : "RS"}
                                </td>
                                <td scope="row">{item.minimum}</td>
                                <td scope="row">{item.maximum}</td>
                                <td scope="row">{item.calorieCount}</td>
                                <td scope="row">
                                  {item.status === 1 ? (
                                    <Badge className="bg-success">
                                      {t("Active")}
                                    </Badge>
                                  ) : (
                                    <Badge className="bg-danger">
                                      {t("Deactive")}
                                    </Badge>
                                  )}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </Table>
                    </div>
                    // ))
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card className="card_100_24">
                <CardBody>
                  <CardTitle>{t("Items")} </CardTitle>
                  {modifierGroupDetails?.items?.length === 0 ? (
                    <p className="text-center my-3">{t("No items found")}</p>
                  ) : (
                    <div className="table-responsive">
                      <Table className="table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>{t("S. No.")}</th>
                            <th>{t("Name(English)")}</th>
                            <th>{t("Name(عربي)")}</th>
                            <th>{t("Minimum Quantity")}</th>
                            <th>{t("Maximum Quantity")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {modifierGroupDetails?.items?.map((item, index) => (
                            <tr key={item._id}>
                              <td scope="row">{index + 1}</td>
                              <td scope="row">{item.name || "-"}</td>
                              <td scope="row">{item.nameAr || "-"}</td>
                              <td scope="row">{item.minQuantity ?? "-"}</td>
                              <td scope="row">{item.maxQuantity ?? "-"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    // ))
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ModifierGroupDetails
